import { Component } from 'vue-property-decorator'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import Vue from 'vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import { State } from 'vuex-class'
import { PageState } from '../../../store/modules/page'
import { getTextractTasks } from '../gql'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { TextTask } from '../interfaces/textTract-task'
import { showErrors } from '@/utils/snack'
import { dateTimeToDisplay } from '@/utils/dateTime'
@Component({
  components: {
    AppBreadcrumbs
  }
})
export default class OcrFileUpload extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'File Upload',
      to: { name: 'OcrFileUpload' }
    },
    {
      text: 'Upload history'
    }
  ]
  dateTimeToDisplay = dateTimeToDisplay
  dataTimer = null as any
  textractTasksList: TextTask[] = []
  textractTasksStatus = false
  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    creator: 'CREATOR',
    createdAt: 'CREATED_AT',
    status: 'STATUS'
  }

  defaultSort = 'CREATED_AT'
  tableLoading = false
  windowSize = {
    w: 0,
    h: 0,
    cW: 0
  }
  jobStatus: any = [
    {
      label: '识别成功',
      value: 'SUCCESS'
    },
    {
      label: '识别失败',
      value: null
    },
    {
      label: '正在识别',
      value: 'DETECTING'
    }
  ]
  presumedFileType = {
    POLICY: 'Policy',
    DRIVER_LICENSE: 'Driver’s License',
    PROGRESSIVE_COMMISSION: 'Progressive Statement',
    COUNTRY_WIDE_COMMISSION: 'Country Wide Statement',
    UNRECOGNIZED: 'Unrecognized'
  }
  @State(state => state.page) page!: PageState

  tableColumn = [
    { field: 'name', title: '上传人', slots: { default: 'name_default' }, sortable: true, resizable: true },
    { field: 'name', title: '文件类型', slots: { default: 'type_default' }, sortable: true, resizable: true },
    { field: 'createdAt', title: '上传日期', slots: { default: 'createdAt_default' }, sortable: false, with: 120 },
    { field: 'status', title: '识别状态', slots: { default: 'status_default' }, sortable: false, with: 120 }
  ]

  mounted () {
    this.getTextractTasks()
    this.getTextractTaskStatusRequest()
  }

  onResize () {
    const container = this.$refs.container as Vue & { clientWidth: number }
    this.windowSize = { w: window.innerWidth, h: window.innerHeight, cW: container.clientWidth }
  }
  getStatusText = (value: string) => {
    if (value === 'SUCCESS') {
      return '识别成功'
    } else if (value === 'DETECTING') {
      return '正在识别'
    } else {
      return '识别失败'
    }
  }
  async getTextractTasks () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || this.defaultSort
    this.tableLoading = true
    try {
      const result = await this.$apollo.query({
        query: getTextractTasks,
        variables: {
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.textractTasksList = result.data.getTextractTasks.textractTasks
      this.tableLoading = false
      this.tableOptions.tablePage.total = result.data.getTextractTasks.paging.totalCount
      this.textractTasksStatus = this.textractTasksList.every((item) => {
        return item.jobStatus === 'SUCCESS'
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getTextractTasks()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getTextractTasks()
  }

  getTextractTaskStatusRequest () {
    this.dataTimer = setInterval(async () => {
      await this.getTextractTasks()
      if (this.textractTasksStatus) {
        clearInterval(this.dataTimer)
      }
    }, 60000)
  }

  toOcrFileUpload (e: any) {
    const { id, jobStatus, storeKey, name } = e.row
    this.$router.push({
      name: 'OcrFileUpload',
      params: {
        id: id + '',
        storeKey,
        jobStatus,
        name
      }
    })
  }
}
